"use client";

import React, { useState, ReactNode } from "react";
import { TipsForWeek } from "@aph/ui-lib-humanx";
import styles from "./swipeSlider.module.scss";

export default function Swipeable(props) {
  const a = [...props?.topTips].map((data, index) => ({ ...data, initialIndex: index }));

  const [data, setData] = useState(a);
  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);

  const [touchStartY, setTouchStartY] = useState(null);
  const [touchEndY, setTouchEndY] = useState(null);

  const minSwipeDistance = 50;

  function onTouchStart(e) {
    setTouchEndX(null);
    setTouchStartX(e.targetTouches[0].clientX);
    console.log({ touchStart: e.targetTouches[0].clientX });

    setTouchEndY(null);
    setTouchStartY(e.targetTouches[0].clientY);
  }

  function onTouchMove(e) {
    setTouchEndX(e.targetTouches[0].clientX);
    setTouchEndY(e.targetTouches[0].clientY);
    console.log({ touchMove: e.targetTouches[0].clientX, diff: e.targetTouches[0].clientX - touchStartX });
  }

  function onTouchEnd() {
    if (touchStartX && touchEndX) swipeHorizontal();
    if (touchStartY && touchEndY) swipeVertical();
  }

  function swipeHorizontal() {
    const xDistance = touchStartX - touchEndX;
    const yDistance = touchStartY - touchEndY;

    if (Math.abs(yDistance) >= Math.abs(xDistance)) {
      return;
    }

    if (minSwipeDistance > xDistance) {
      setTouchEndX(null);
      setTouchStartX(null);
    }

    const isLeftSwipe = xDistance > minSwipeDistance;
    const isRightSwipe = xDistance < -minSwipeDistance;

    if (isLeftSwipe) {
      const newImages = [...data];
      newImages.unshift(newImages.pop());
      setTouchEndX(null);
      setTouchStartX(null);
      setData(newImages);
      // props.onSwipeLeft();
    }

    if (isRightSwipe) {
      console.log("swipe right");
      const newImages = [...data];
      newImages.unshift(newImages.pop());
      setTouchEndX(null);
      setTouchStartX(null);
      setData(newImages);
      // props.onSwipeRight();
    }
  }

  function swipeVertical() {
    const xDistance = touchStartX - touchEndX;
    const yDistance = touchStartY - touchEndY;

    if (Math.abs(xDistance) >= Math.abs(yDistance)) {
      return;
    }

    const isUpSwipe = yDistance > minSwipeDistance;
    const isDownSipe = yDistance < -minSwipeDistance;

    if (isDownSipe) {
      console.log("swipe down");
      // props.onSwipeDown();
    }

    if (isUpSwipe) {
      console.log("swipe up");

      // props.onSwipeUp();
    }
  }

  return (
    <div className={styles.container}>
      {data.map((info, index) => {
        return (
          <React.Fragment key={info.id}>
            <div
              className={styles.card}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
              style={{
                transform:
                  index === data?.length - 1
                    ? `translate3d(${touchEndX ? touchEndX - touchStartX : 0}px,0px,0px)`
                    : index === data?.length - 2
                      ? `translate3d(0,-30px, 0) scale(0.9)`
                      : `translate3d(0,-60px,0) scale(0.8)`,
              }}
            >
              <TipsForWeek
                shadowColor={info.initialIndex % 2 !== 0 ? "#EE691F" : "#CFD7FF"}
                backgroundColor={info.initialIndex % 2 !== 0 ? "#F15A24" : "#D7DFFF"}
                title={info?.attributes?.Title}
                description={info?.attributes?.Description}
                sideImg={info?.attributes?.Image?.data?.attributes?.url}
                fontColur={info.initialIndex % 2 !== 0 ? "#ffffff" : "#222222"}
              />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export interface SwipeableProps {
  children: ReactNode;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
}
